import { action } from "typesafe-actions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { IPolicy } from "./Policies.types";

export const FETCH_ALL_POLICIES_LIST_PROGRESS =
  "FETCH_ALL_POLICIES_LIST_PROGRESS";
export const FETCH_ALL_POLICIES_LIST_SUCCESS =
  "FETCH_ALL_POLICIES_LIST_SUCCESS";
export const FETCH_ALL_POLICIES_LIST_FAILED = "FETCH_ALL_POLICIES_LIST_FAILED";

export const fetchAllPoliciesListProgress = () =>
  action(FETCH_ALL_POLICIES_LIST_PROGRESS);
export const fetchAllPoliciesListSuccess = (list: IPolicy[]) =>
  action(FETCH_ALL_POLICIES_LIST_SUCCESS, { list });
export const fetchAllPoliciesListFailed = () =>
  action(FETCH_ALL_POLICIES_LIST_FAILED);

export const fetchAllPoliciesListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState,
    searchValue: IDatatableV2AdvancedSearchFilter,
    line_of_business: string | undefined,
    setTableName: (tableName: string) => void,
    otherFilters?: {
      customer_name?: string;
      address?: string;
      customer_code?: string;
      customer_policy_id?: string;
      policy_number?: string;
      branch_code?: string;
      producer_code?: string;
      insurer_code?: string;
    }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      dispatch(fetchAllPoliciesListProgress());
      let finalUrl = `/policy/get-all-customer-policy-details?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&status=ACTIVE`;
      if (line_of_business === undefined) {
     
        setTableName("latest_all_customer_policy_details");
      } else if (line_of_business === "Business Policy") {
        finalUrl = `/policy/get-all-customer-policy-details?column=line_of_business&value=Business Policy&pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&status=ACTIVE`;

        setTableName("latest_policy_business_customer_info");
      } else if (line_of_business === "Automobile Policy") {
        finalUrl = `/policy/get-all-customer-policy-details?column=line_of_business&value=Automobile Policy&pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&status=ACTIVE`;

       
        setTableName("latest_policy_automobile_customer_info");
      } else if (line_of_business === "Commercial Auto Policy") {
        finalUrl = `/policy/get-all-customer-policy-details?column=line_of_business&value=Commercial Auto Policy&pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&status=ACTIVE`;

    
        setTableName("latest_policy_commauto_customer_info");
      } else if (line_of_business === "Habitational Policy") {
        finalUrl = `/policy/get-all-customer-policy-details?column=line_of_business&value=Habitational Policy&pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&status=ACTIVE`;

 
        setTableName("latest_policy_habitational_customer_info");
      } else if (line_of_business === "Life & Financial Policy") {
        finalUrl = `/policy/get-all-customer-policy-details?column=line_of_business&value=Life & Financial Policy&pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&status=ACTIVE`;

        setTableName("latest_policy_life_basic_details_customer_info");
      }

      if(date.rangeType !== "allTimes" && searchValue.length === 0){
        finalUrl = finalUrl+ `&to_date=${date.dates.toDate}&from_date=${date.dates.fromDate}`
      }

      // Build combined advance filter: existing searchValue + otherFilters
      const combinedAdvanceFilter = [...searchValue];
      if (otherFilters?.customer_name) {
        combinedAdvanceFilter.push({
          column: ["customer_name"],
          operator: "CONTAINS",
          value: otherFilters.customer_name,
          logicalOperator: "OR",
        });
      }
      if (otherFilters?.address) {
        combinedAdvanceFilter.push({
          column: ["address"],
          operator: "CONTAINS",
          value: otherFilters.address,
          logicalOperator: "OR",
        });
      }
      if (otherFilters?.customer_code) {
        combinedAdvanceFilter.push({
          column: ["customer_code"],
          operator: "EQUAL",
          value: otherFilters.customer_code,
          logicalOperator: "AND",
        });
      }
      if (otherFilters?.customer_policy_id) {
        combinedAdvanceFilter.push({
          column: ["customer_policy_id"],
          operator: "EQUAL",
          value: otherFilters.customer_policy_id,
          logicalOperator: "AND",
        });
      }
      if (otherFilters?.policy_number) {
        combinedAdvanceFilter.push({
          column: ["policy_number"],
          operator: "EQUAL",
          value: otherFilters.policy_number,
          logicalOperator: "AND",
        });
      }
      if (otherFilters?.branch_code) {
        combinedAdvanceFilter.push({
          column: ["branch_code"],
          operator: "EQUAL",
          value: otherFilters.branch_code,
          logicalOperator: "AND",
        });
      }
      if (otherFilters?.producer_code) {
        combinedAdvanceFilter.push({
          column: ["producer_one_code"],
          operator: "EQUAL",
          value: otherFilters.producer_code,
          logicalOperator: "AND",
        });
      }
      if (otherFilters?.insurer_code) {
        combinedAdvanceFilter.push({
          column: ["insurer"],
          operator: "EQUAL",
          value: otherFilters.insurer_code,
          logicalOperator: "AND",
        });
      }

      if (combinedAdvanceFilter.length > 0) {
        finalUrl = finalUrl + `&advanceFilter=${JSON.stringify(combinedAdvanceFilter)}`;
      }

      if (status !== "-1") {
        finalUrl = finalUrl + `&column=current_policy_status&value=${status}`;
      }

      const res = await api.get(finalUrl);
      const data: IPolicy[] = res.data.data;

      dispatch(fetchAllPoliciesListSuccess(data));
    } catch (err: any) {
      dispatch(fetchAllPoliciesListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

  export const deletePolicyAsync =
  (
    customerPolicyId: number,
    line_of_business: string,
    status: string,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(saveLoaderProgress());
      const res = await api.post(
        "/policy/update-status-all-policies",
        {
          customer_policy_id: customerPolicyId,
          line_of_business: line_of_business,
          status: status,
        }
      );
      onCallback(true);
      dispatch(
        showMessage({
          type: "success",
          message: "Policy deleted successfully!",
          displayAs: "snackbar",
        })
      );
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_ALL_POLICIES_STATE = "CLEAR_ALL_POLICIES_STATE";

export const clearAllPoliciesState = () => action(CLEAR_ALL_POLICIES_STATE);
